export const PRICING_POTENTIAL_SLIDER_DATA = "pricing_potential_slider_data";
export const PRICING_POTENTIAL_CHART_DATA = "pricing_potential_chart_data";
